
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject, Input } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { GenericLogServices, LogEntry, UserConfig } from './generic-log.services';
import { NzTableComponent, NzTableFilterValue, NzTableQueryParams } from 'ng-zorro-antd/table';
import { FormGroup } from '@angular/forms';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { AgInputNumberField, ColDef, ColumnApi, ColumnMovedEvent, ColumnPinnedEvent, ColumnResizedEvent, ColumnState, GridApi, GridOptions, GridReadyEvent, ICellRendererParams, IInfiniteRowModel, RowDoubleClickedEvent, SortChangedEvent, ValueFormatterParams } from '@ag-grid-community/core';
import { CustomLoadingOverlay, TabQuerySettings } from '../query-executor/query-executor.component';
import { ThemeService } from 'src/app/services/theme.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import moment from 'moment';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NzDrawerComponent } from 'ng-zorro-antd/drawer';
import { SearchProperties } from 'src/app/system-utils/search-input-new/search-input-new.component';
import { Variable } from '../formula-tester/formula-tester.component';

export interface LogConfiguration{
    tableName:string;
    codecompany:number;
    codeproduct:number;
    metadataFields:LogCustomFields[];
}

export interface LogCustomFields{
    colid:string;
    field:string;
    type:string;
    formula?:string;
    isIcon?:boolean;
    format?:string;
    align?:string;
}


@Component({
  selector: 'generic-log',
  templateUrl: './generic-log.component.html',
  styleUrls: ['./generic-log.component.scss'],
  standalone:false
})


export class GenericLogComponent implements OnInit, OnDestroy {
    logs: LogEntry[] = [];
    searchText: string = '';
    private sub!: Subscription;
    resourceid;
    userConfig:UserConfig;
    codecompany = null;
    codeproduct = null;
    tableName = null;
    metadataFields:LogCustomFields[] = [];
    filterGroup:FormGroup;
    @ViewChild('wrapper', { static: true }) wrapperRef!: ElementRef;
    @ViewChild('logTable',{ static: false }) table:NzTableComponent<any>;
    @ViewChild('drawer', {static: false}) drawer:NzDrawerComponent;
    currentFilter: {
            key: string;
            value: NzTableFilterValue
    }[]=[];
    gridAPI: GridApi;
    visibleDrawer:boolean = false;
    jsonFormated:String = '';
    dataSource: { getRows(params: any): void; };
    configuration: LogConfiguration;
    @Input() data:any = null; 
    variables:Variable[] = [];
    showFasterFilter:boolean = false;
    searchInputCodeCompany:SearchProperties ={
        entityName:'Mktpcompanies',
        fields:{keyField:'CODECOMPANY', valueField:'NAME'},
        placeholder:this.ls.instant("CODECOMPANY"),
        showKey:true,
        size:'small'
    }

    searchInputCodeProduct:SearchProperties ={
        entityName:'Mktpproducts',
        fields:{keyField:'CODEPRODUCT', valueField:'NAME'},
        placeholder:this.ls.instant("CODEPRODUCT"),
        showKey:true,
        size:'small',
        disabled:true,
        condition: 'CODECONTRACT = ( SELECT CODECONTRACT FROM MKTPCOMPANIES WHERE CODECOMPANY={@CODECOMPANY})'
    }

    changeCodeCompany:Subject<any> = new Subject<any>();

    onChangeCodeCompany(evento){
        
        this.searchInputCodeProduct.disabled = true;
        setTimeout(()=>{
            this.searchInputCodeProduct.disabled = false;

            let variable = this.variables.find(d=>d.key=='@CODECOMPANY');

            if ( variable == null){
                this.variables.push({
                    key:'@CODECOMPANY',
                    value:evento,
                    type:'texto'
                });
            }else{
                variable.value = evento;
            }
            
            this.changeCodeCompany.next(evento)

            this.codecompany = evento;
            this.refreshData();
        },100);
    }


    onChangeCodeProduct(evento){
        this.codeproduct = evento;
        this.refreshData();
    }

    constructor(
            private logService: GenericLogServices,
            public ThemeService:ThemeService,
            public ls:LanguageServices,
            @Inject(MAT_DIALOG_DATA) public dataDialog
        ) {
            
            if  ( dataDialog!= null ){
                this.configuration =  dataDialog as LogConfiguration;
                this.codeproduct = this.configuration.codeproduct;
                this.codecompany = this.configuration.codecompany;
                this.tableName = this.configuration.tableName;
                this.metadataFields = this.configuration.metadataFields;
            }
        }


    onGridReady(event: GridReadyEvent) {
        this.gridAPI = event.api;
        this.gridAPI.setGridOption('datasource',this.dataSource);
        this.logService.loadGridPreference(this.resourceid).then((val:Object)=>{
            if ( val!= null && val['PREFERENCE']!= null ){
                this.userConfig = {
                    columnState: JSON.parse(val['PREFERENCE'])['columnState'] as ColumnState[],
                };   
                this.setState(null); 
            }
        });
        
        
    }

    refreshData():void{
        this.gridAPI.refreshInfiniteCache();
    }


    createType(colField:ColDef, field:LogCustomFields){
        if ( field.type == 'number' && !field.isIcon){
            colField.filter='agNumberColumnFilter';
            colField.type= 'numericColumn';
        }else{
            if ( field.type == 'datetime' && !field.isIcon){
                colField.filter= 'agDateColumnFilter',
                colField.type='dateColumn',
                colField.valueFormatter=(data: ValueFormatterParams)=>{
                    
                    if (  data.value!= null && data.value != 'null' &&  data.value != "" ){
                        return moment(data.value).format("DD/MM/yyyy HH:mm:ss.SSS");
                    }else{
                        return "";
                    }
                }
            }else{
                if ( field.isIcon){
                    colField.cellRenderer=(params:ICellRendererParams)=>{
                        if (
                            params.value === "null" ||
                            params.value === null ||
                            params.value ===   ""
                        ) {
                            return "";
                        }else{
                            if (field.formula != null) {
                                let data = params.value;
                                const runCode = new Function("param", field.formula);

                                let evaluation =runCode(data);
                                return `<i  class="${evaluation}"></i><span class="span10"></span>`
                            }
                             return '';    
                        }           
                    }
                }
            }
        }
    }

    ngOnInit(): void {
        
        if ( this.data!= null ){
                this.configuration =  JSON.parse(this.data) as LogConfiguration;
                this.codeproduct = this.configuration.codeproduct;
                this.codecompany = this.configuration.codecompany;
                this.tableName = this.configuration.tableName;
                this.metadataFields = this.configuration.metadataFields;
                this.showFasterFilter = true;
        }


        this.fields = [
            {
                colId:this.tableName+'.CODECOMPANY',
                field:'codecompany',
                headerName: this.ls.instant(this.tableName+'.CODECOMPANY'),
                sortable:true,
                resizable: true,
                filter:'agNumberColumnFilter',
                type: 'numericColumn',
            },
            {
                colId:'C.NAME',
                field:'nameCompany',
                headerName: this.ls.instant(this.tableName+'.NAMECOMPANY'),
                sortable:true,
                resizable: true,
                filter:true
            },
            {
                colId:this.tableName+'.CODEPRODUCT',
                field:'codeproduct',
                headerName: this.ls.instant(this.tableName+'.CODEPRODUCT'),
                filter:'agNumberColumnFilter',
                type: 'numericColumn',
                sortable:true,
                resizable: true
            },
            {
                colId:this.tableName+'.IDCONF',
                field:'idconf',
                headerName: this.ls.instant(this.tableName+'.IDCONF'),
                sortable:true,
                resizable: true,
                filter:'agNumberColumnFilter',
                type: 'numericColumn'
            },
            {
                colId:this.tableName+'.RECMODIFIEDON',
                field:'recmodifiedon',
                headerName: this.ls.instant(this.tableName+'.RECMODIFIEDON'),
                sortable:true,
                filter: 'agDateColumnFilter',
                resizable: true,
                type:'dateColumn',
                valueFormatter:(data: ValueFormatterParams)=>{
                    
                    if (  data.value!= null && data.value != 'null' &&  data.value != "" ){
                        return moment(data.value).format("DD/MM/yyyy HH:mm:ss.SSS");
                    }else{
                        return "";
                    }
                }
            },
            {
                colId:this.tableName+'.REQUESTBODY',
                field:'requestbody',
                cellStyle: { textAlign: 'center' },
                headerName: this.ls.instant(this.tableName+'.REQUESTBODY'),
                sortable:true,
                resizable: true,
                cellRenderer:GridButtonRendererComponent,
                cellRendererParams:{
                    label: this.ls.instant(this.tableName+'.REQUESTBODY'),
                    onClick: this.openDrawer.bind(this)
                }
            },
            {
                colId:this.tableName+'.RESPONSEBODY',
                field:'responsebody',
                cellStyle: { textAlign: 'center' } ,
                headerName: this.ls.instant(this.tableName+'.RESPONSEBODY'),
                sortable:true,
                resizable: true,
                cellRenderer:GridButtonRendererComponent,
                cellRendererParams:{
                    label: this.ls.instant(this.tableName+'.RESPONSEBODY'),
                    onClick: this.openDrawer.bind(this)
                }

            },
        ]

        this.resourceid = 'log_request_response_'+this.tableName;
        
        for (var field of this.metadataFields){
            let colField:ColDef = {
                colId: field.colid,
                field: field.field,
                sortable:true,
                resizable: true,
                headerName: this.ls.instant(field.colid),
            }

            if ( field.align != null ){
                colField.cellStyle = { textAlign: field.align }
            }

            this.createType(colField,field);
            
            this.fields.push(colField);
        }

       
        this.dataSource = {
        
            getRows: (params: any) => {

                const pageSize = params.endRow - params.startRow;
                const page = params.startRow;
                
                this.showLoadingOverlay();
                this.logService.getLogsStream(
                        this.tableName,
                        this.metadataFields, 
                        page, 
                        pageSize, 
                        params.sortModel, 
                        params.filterModel,
                        this.codecompany,
                        this.codeproduct)
                .then(log => {
                    params.successCallback(log, log == null || log.length == 0 ? 0 :log[0].totalRows);
                })
                .catch(error=>{
                    params.successCallback([], 0); 
                    GlobalErrorHandler.showError(error);
                })
                .finally(()=>{
                     this.hideLoadingOverlay();
                });
            }
        }

    }

    public loadingOverlayComponent: any = CustomLoadingOverlay;

    public loadingOverlayComponentParams: any = {
        loadingMessage: "QUERY_EXECUTOR.AGGRID.LOADING",
    };

    public gridOptions: GridOptions = {
        enableRangeSelection: true,
    //   onRowDoubleClicked:(event:RowDoubleClickedEvent)=>{
    //       this.openPopUp(event);
    //   },
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
        }
    };

    showLoadingOverlay() {
        this.gridAPI.showLoadingOverlay();
    }

    hideLoadingOverlay() {
        this.gridAPI.hideOverlay();
    }

    fields:ColDef[] =[];

    openDrawer(valueChanges:ICellRendererParams){
        this.drawer.nzTitle = valueChanges.colDef.headerName+ " | " + valueChanges.data['recmodifiedon']; ;
        
        if ( valueChanges.value!= null ){
            this.jsonFormated =  this.formatJSON((valueChanges.value as string));
        }else{
            this.jsonFormated =  null;
        }
        
        this.visibleDrawer = true;
        this.drawer.open();
    }

    formatJSON(json):string{
        try{
            if ( json instanceof String || typeof(json)=='string'){
                return JSON.stringify(JSON.parse(json.toString()),null,2);
            }else{
                return JSON.stringify(json,null,2);
            }
            
        }catch(erro){
            return erro;
        }
    }

    closeDrawer(){
        this.drawer.close();
        this.visibleDrawer = false;
    }

    ngOnDestroy(): void {
        if ( this.sub!= null ){
            this.sub.unsubscribe();
        }
        
    }

    sortChanged(param:SortChangedEvent){
          this.stateSave();
    }
    
    stateSave(){      
        if ( this.userConfig == null ){
            this.userConfig = {
                columnState: this.gridAPI.getColumnState()
            }
            
        }else{
            this.userConfig.columnState = this.gridAPI.getColumnState();
        }
        this.saveUserConfig()
    }

    setState(evento){
        if ( this.userConfig!= null ){
            let success:boolean = this.gridAPI.applyColumnState({ state: this.userConfig.columnState,applyOrder: true });
        }
    }
    
    saveUserConfig() {
        
        this.logService.saveUserPreference(this.resourceid, this.userConfig);
    }
    
    public onReoder(evento:ColumnMovedEvent): void {
        if ( evento.finished ){
            this.stateSave();
        }
    }
    
    public onPinned(evento:ColumnPinnedEvent): void {
        this.stateSave();
    }
      
    public onResize(event: ColumnResizedEvent): void {
        try {
            if (event.finished) {
            this.stateSave();
            } 
        } catch (Exception) {
            throw Exception;
        }
    }

    
}



@Component({
  selector: 'app-grid-button-renderer',
  standalone:false,
  template: `
    
    <button 
                        nz-button 
                            nzType="primary" 
                            (click)="onClick()"
                            [nz-tooltip]="label|translate">
                            <nz-icon [nzType]="'search'"></nz-icon>
                                {{'genericlog.open'|translateTA}}
                    </button>
  `
})
export class GridButtonRendererComponent {
  params: any;
  label:string;
  labelString : string;
  agInit(params: any): void {
    this.label = params.label;
    this.params = params;
    
  }

  onClick(): void {
    if (this.params.onClick) {
      this.params.onClick(this.params);
    }
  }
}
